/**
 *
 * GetStartedMenu
 *
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Wrapper,
  Menu,
  RightNavContent,
  Button,
  Content,
} from './styledComponents';

import Logo from 'components/Logo';
import { MARKETING_SIGNUP_URL } from 'utils/marketing';

const GetStartedMenu = ({ children }) => {
  // Was read off React internals (`children._owner.pendingProps.location`),
  // which only ever worked because react-router v5 passed `location` as a prop
  // to the routed child. v7 renders `element` and passes nothing, so that path
  // is permanently undefined — read the router directly.
  const { pathname } = useLocation();
  const isTerms = pathname === '/terms';

  // Determine content width: wider for terms, default 500px
  const getContentWidth = () => {
    if (isTerms) return 868;
    return 500;
  };

  return (
    <Wrapper>
      <Menu>
        <Logo withText={true} />
        <RightNavContent>
          {/*
            Sign-up lives on the marketing site — send new customers there.

            There is deliberately no "Already have an account? Sign In" link
            beside it. It used to render only when `pathname === '/sign-up'`,
            and /sign-up is now an interstitial that immediately forwards to
            the marketing product page, so in practice nobody could act on it.
            An unauthenticated visitor reaches sign-in without it: `/` already
            redirects to /sign-in (routes.js), which is where the app puts a
            signed-out user by default.
          */}
          <Button
            as='a'
            href={MARKETING_SIGNUP_URL}
            className='get-started-menu__button'>
            Get Movebooth
          </Button>
        </RightNavContent>
      </Menu>
      <Content divWidth={getContentWidth()}>
        {children}
      </Content>
    </Wrapper>
  );
}

export default GetStartedMenu;
